import React from 'react';
import {
  Button,
  Drawer,
  Separator,
  useOverlayState,
} from '@heroui/react';

export interface AvatarSelectDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelectFromAlbum: () => void;
  onTakePhoto: () => void;
}

/**
 * 头像选择抽屉组件
 *
 * 提供三个选项：
 * - 从相册选择
 * - 拍照
 * - 取消
 */
export function AvatarSelectDrawer({
  open,
  onOpenChange,
  onSelectFromAlbum,
  onTakePhoto,
}: AvatarSelectDrawerProps) {
  const drawer = useOverlayState({
    isOpen: open,
    onOpenChange,
  });

  const handleSelectFromAlbum = () => {
    onSelectFromAlbum();
    drawer.close();
  };

  const handleTakePhoto = () => {
    onTakePhoto();
    drawer.close();
  };

  return (
    <Drawer state={drawer}>
      <Drawer.Trigger className="sr-only">头像选择</Drawer.Trigger>
      <Drawer.Backdrop>
        <Drawer.Content placement="bottom">
          <Drawer.Dialog className="rounded-t-2xl bg-background pb-8 text-foreground">
            <Drawer.Handle />
            <Drawer.Body className="gap-0 p-0">
              <Button
                variant="ghost"
                size="lg"
                className="w-full justify-center"
                onPress={handleSelectFromAlbum}
              >
                从相册选择
              </Button>
              <Separator />
              <Button variant="ghost" size="lg" className="w-full justify-center" onPress={handleTakePhoto}>
                拍照
              </Button>
              <Separator />
              <Button slot="close" variant="ghost" size="lg" className="w-full justify-center">
                取消
              </Button>
            </Drawer.Body>
          </Drawer.Dialog>
        </Drawer.Content>
      </Drawer.Backdrop>
    </Drawer>
  );
}
